module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-card-title', {
    staticClass: "overline",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("alert"), _vm._v(" "), (_vm.left.id === _vm.right.id) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "success",
      "color": "success"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.sameTitle) + "\n  ")]) : _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.left) ? _c('v-card', {
    staticClass: "ma-3",
    on: {
      "click": function($event) {
        return _vm.$emit("input", _vm.left)
      }
    }
  }, [_vm._t("left-title"), _vm._v(" "), _vm._t("left-object", function() {
    return [(_vm.displayComponent) ? _c(_vm.displayComponent, _vm._b({
      tag: "component"
    }, 'component', _vm.displayComponentLeftAttrs, false)) : _c('pre', [_vm._v("              " + _vm._s(_vm.left) + "\n            ")])]
  }), _vm._v(" "), (_vm.withEdit) ? _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "fab": "",
      "absolute": "",
      "top": "",
      "right": "",
      "small": "",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.$emit("edit", _vm.left)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), (_vm.right) ? _c('v-flex', {
    attrs: {
      "xs16": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-3",
    on: {
      "click": function($event) {
        return _vm.$emit("input", _vm.right)
      }
    }
  }, [_vm._t("right-object", function() {
    return [(_vm.displayComponent) ? _c(_vm.displayComponent, _vm._b({
      tag: "component",
      staticClass: "ma-0"
    }, 'component', _vm.displayComponentRightAttrs, false)) : _c('pre', [_vm._v("              " + _vm._s(_vm.right) + "\n            ")])]
  })], 2)], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9710c8ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/merge/ObjectSelector.vue
// module id = 1671
// module chunks = 2